export const CONTACT = {
  person: "Bhargav Patel",
  phone: "9408780029",
  displayPhone: "+91 94087 80029",
  whatsappNumber: "919408780029",
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    message ||
      "Hello Bhargav Patel, I am interested in a B2B inquiry for Rorix road safety equipment."
  )}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
